module.exports = __webpack_public_path__ + "img/kjjh_gallery10.dff5f729.jpg";